/**
 * Custom error thrown when decryption fails.
 * Allows calling services to handle corrupted data appropriately.
 */
export class DecryptionError extends Error {
  constructor(
    message: string,
    public readonly storageKey?: string,
    public readonly originalError?: unknown,
  ) {
    super(message);
    this.name = 'DecryptionError';

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ('captureStackTrace' in Error && typeof (Error as any).captureStackTrace === 'function') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Error as any).captureStackTrace(this, DecryptionError);
    }
  }
}
